export default __webpack_public_path__ + "static/frame-2226-1--a889e8cb5de7d092a1082ec5cebc6e4c.png";